import { toast } from "sonner";
import { useUpdatePaymentEmailSendingMutation } from "../api/queries/paymentsQueries";
import { useAuth } from "../hooks/useAuth";

interface InvoiceEmailSendingToggleProps {
  invoiceId: string;
  isEmailSendingEnabled: boolean;
}

export function InvoiceEmailSendingToggle({
  invoiceId,
  isEmailSendingEnabled,
}: InvoiceEmailSendingToggleProps) {
  const { canMutateOrg } = useAuth();
  const updateMutation = useUpdatePaymentEmailSendingMutation();

  const handleToggle = async () => {
    if (!canMutateOrg) return;
    const nextValue = !isEmailSendingEnabled;
    try {
      await updateMutation.mutateAsync({
        externalId: invoiceId,
        isEmailSendingEnabled: nextValue,
      });
      toast.success(
        nextValue ? "Email sending enabled" : "Email sending disabled",
      );
    } catch (error) {
      toast.error("Failed to update email sending settings");
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <label className="flex cursor-pointer items-center gap-2 text-sm text-slate-600">
        <span>Send emails</span>
        <button
          type="button"
          role="switch"
          aria-checked={isEmailSendingEnabled}
          onClick={handleToggle}
          disabled={!canMutateOrg || updateMutation.isPending}
          className={`relative inline-flex h-7 w-12 items-center rounded-full transition ${
            isEmailSendingEnabled ? "bg-blue-600" : "bg-slate-300"
          } ${canMutateOrg ? "cursor-pointer" : "cursor-not-allowed"} disabled:cursor-not-allowed disabled:opacity-60`}
        >
          <span
            className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition ${
              isEmailSendingEnabled ? "translate-x-5" : "translate-x-1"
            }`}
          />
        </button>
      </label>
      {!isEmailSendingEnabled ? (
        <p className="max-w-xs text-right text-xs text-slate-500">
          This invoice is excluded from templates and drafts.
        </p>
      ) : null}
    </div>
  );
}
